// Shared, stateless presentation helpers — dates, initials, and the
// semantic color maps for status / priority / module type. Centralizing
// these guarantees a ticket that is "In Progress" looks identical on every
// screen, and that adding a new status only touches one file.
import {
  statusColor as mapStatusColor,
  priorityColor as mapPriorityColor,
  priorityIcon as mapPriorityIcon,
  typeColor as mapTypeColor,
} from '@/theme/semantic';

export default {
  methods: {
    // Date only, e.g. "Jun 27, 2026".
    formattedDate(dateString) {
      if (!dateString) return '';
      const date = new Date(Date.parse(dateString));
      if (isNaN(date)) return dateString;
      return date.toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC',
      });
    },
    // Date + time, e.g. "Jun 27, 2026, 2:15 PM".
    formattedDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(Date.parse(dateString));
      if (isNaN(date)) return dateString;
      return date.toLocaleString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
      });
    },
    initials(name) {
      if (!name) return '?';
      const parts = String(name).replace(/[^a-zA-Z ]/g, '').trim().split(/\s+/).filter(Boolean);
      return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
    },
    statusColor(status) {
      return mapStatusColor(status);
    },
    priorityColor(priority) {
      return mapPriorityColor(priority);
    },
    priorityIcon(priority) {
      return mapPriorityIcon(priority);
    },
    typeColor(type) {
      return mapTypeColor(type);
    },
    pct(part, total) {
      return total ? Math.round((part / total) * 100) : 0;
    },
    // Best-available label for the signed-in user (used as actor on writes).
    currentUserLabel() {
      const u = this.user_data;
      if (!u) return 'system';
      const info = u.employee_information || {};
      return info.fullname || info.company_id || u.email || 'system';
    },
  },
};
